// hasModificator
$.fn.hasModificator = function (modificator) {
	var elementClass = this[0].className;

	if (elementClass.indexOf(`_${modificator}`) + 1) return true;
	else return false;
};
// findEl
$.fn.findEl = function (element) {
	var block = '.'+this[0].classList[0],
		isUpperCase = element[0].toUpperCase() == element[0];

	if (!!isUpperCase) return this.find(`${block}${element}`);
	else  return this.find(`${block}__${element}`);
};
// filterMod
$.fn.filterMod = function (modificator) {
	var element = '.'+this[0].classList[0];

	return this.filter(`${element}_${modificator}`);
};
// notMod
$.fn.notMod = function (modificator) {
	var element = '.'+this[0].classList[0];

	return this.not(`${element}_${modificator}`);
};
// addMod
$.fn.addMod = function (modificator) {
	var element = this[0].classList[0];

	return this.addClass(`${element}_${modificator}`);
};